<template>
  <div class="wrap-lg">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{commonUtils.getDictName('service_type', service.infoId)|filterService}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/service/detail?sid=' + serviceId }">在线培训</el-breadcrumb-item>
      <el-breadcrumb-item>{{service.webTestContentDetailEditRequestList[0].title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="18" class="reach-html">
          <h2>{{service.webTestContentDetailEditRequestList[0].title}}</h2>
          <div v-for="item in service.webTestContentDetailEditRequestList" :key="item.id">
            <div v-html="item.content"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <ad-right></ad-right>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getInfo } from '@/api/test/testContent'
import $ from 'jquery'
export default {
  name: 'detail',
  data () {
    return {
      currentRow: 0,
      serviceId: null,
      itemId: null,
      service: {
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user.userInfo
    },
    vipInfo () {
      return this.$store.state.user.vipInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  mounted () {
    var that = this
    this.currentRow = that.$route.query.row
    this.itemId = that.$route.query.itemId
    window.servicePlayHandel = function (event) {
      that.servicePlayHandel(event)
      window.event.target.pause()
      window.event.cancelBubble = true
      window.event.returnValue = false
      window.event.preventDefault()
      window.event.stopPropagation()
      return false
    }
    window.toTime0 = function (event) {
      window.event.target.currentTime = 0
    }
    this.serviceId = this.$route.query.sid
    this.getInfo()
  },
  filters: {
    filterService (str) {
      if (str && str.split('_').length > 1) {
        return str.split('_')[1]
      } else {
        return ''
      }
    }
  },
  methods: {
    toPage (path) {
      this.$router.push({
        name: path,
        service: {}
      })
    },
    servicePlayHandel (event) {
      let logx = false
      // 先判断路由是否登录访问
      if (!this.user) {
        logx = true
        this.$login({})
      }
      if ((!this.vipInfo || !this.vipInfo.vipEdate) && !logx) {
        this.vip({})
      }
    },
    neeVipPlay (content) {
      let test = 0
      if (test === 1) {
        return content
      }
      let currentVip = (this.user && this.vipInfo && this.vipInfo.vipEdate)
      var outer = $('<div></div>')
      var str = content
      var nodex = $(str)
      outer.append(nodex)
      var video = nodex.find('video')
      video.each(function (index, node) {
        let isVip = $(node).find('source[isvip]')
        if (!currentVip && isVip.length > 0) {
          $(node).attr('onclick', 'window.servicePlayHandel()')
          $(node).attr('controls', false)
        }
      })
      return outer[0].outerHTML
    },
    neeVipPlay1 (content) {
      let test = 0
      if (test === 1) {
        return content
      }
      /* if (this.user && this.vipInfo && this.vipInfo.vipEdate) {
        return content
      } */
      let currentVip = (this.user && this.vipInfo && this.vipInfo.vipEdate)
      var outer = $('<div></div>')
      var str = content
      var nodex = $(str)
      outer.append(nodex)
      var video = nodex.find('video')
      video.each(function (index, node) {
        let displayType = $(node).css('display')
        let floatType = $(node).css('float')
        let height = $(node).attr('height')
        let widht = $(node).attr('width')
        if (displayType === 'block') {
          height = '100%'
          widht = '100%'
        } else {
          height += 'px'
          widht += 'px'
        }
        let isVip = $(node).find('source[isvip]')
        if (!currentVip && isVip.length > 0) {
          // if (!currentVip) {
          var xdiv = `<span style="position: relative;display: ${displayType};float:${floatType}">
<span style="position: absolute;width: ${widht};height: ${height};z-index: 1;text-align: center;color: red;" onclick="window.servicePlayHandel()">会员观看</span>
</span>`
          var div = $(xdiv)
          $(node).after(div)
          $(node).remove()
          div.append($(node))
        }
      })
      return outer[0].outerHTML
    },
    getInfo () {
      let param = {}
      param.id = this.serviceId
      getInfo(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData.webTestContentDetailEditRequestList && result.bizData.webTestContentDetailEditRequestList.length > 0) {
            for (let i = 0; i < result.bizData.webTestContentDetailEditRequestList.length; i++) {
              let node = result.bizData.webTestContentDetailEditRequestList[i]
              if (node.id !== this.itemId) {
                result.bizData.webTestContentDetailEditRequestList.splice(i, 1)
                i--
              }
            }
            result.bizData.webTestContentDetailEditRequestList.filter(node => {
              node.content = this.neeVipPlay1(node.content)
            })
          }
          this.service = result.bizData
          this.$nextTick(() => {
            $('video').attr('controlsList', 'nodownload')
            var video = $('video')
            let currentVip = (this.user && this.vipInfo && this.vipInfo.vipEdate)
            video.each(function (index, node) {
              let isVip = $(node).find('source[isvip]')
              if (!currentVip && isVip.length > 0) {
                $(node).attr('onclick', 'window.servicePlayHandel()')
                // $(node).attr('controls', false)
                $(node).attr('onplay', 'window.servicePlayHandel()')
                $(node).attr('ontimeupdate', 'window.toTime0()')
              }
            })
            $('video').bind('contextmenu', function () { return false })
          })
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style scoped>
  .studyTitleClz:hover{
    cursor: pointer;
  }
  h4{
    border-left: solid 6px #32A08C;padding-left: 10px
  }
</style>
